import { render, staticRenderFns } from "./DFieldText.vue?vue&type=template&id=785c28f6&"
import script from "./DFieldText.vue?vue&type=script&lang=js&"
export * from "./DFieldText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports